import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Box,
} from '@mui/material';
import { Check, AlertCircle, X, Loader } from 'lucide-react';

interface AlertProps {
  open: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  type: 'loading' | 'success' | 'error' | 'confirm';
  message: string;
  title?: string;
}

export const CustomAlert: React.FC<AlertProps> = ({
  open,
  onClose,
  onConfirm,
  type,
  message,
  title
}) => {
  const getAlertContent = () => {
    switch (type) {
      case 'loading':
        return (
          <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" gap={2}>
            <Loader className="animate-spin" size={40} color="#22C55E" />
            <DialogContentText sx={{ color: '#fff' }}>
              {message}
            </DialogContentText>
          </Box>
        );
      case 'success':
        return (
          <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" gap={2}>
            <Check size={40} color="#22C55E" />
            <DialogContentText sx={{ color: '#fff' }}>
              {message}
            </DialogContentText>
          </Box>
        );
      case 'error':
        return (
          <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" gap={2}>
            <X size={40} color="#FF3D3D" />
            <DialogContentText sx={{ color: '#fff' }}>
              {message}
            </DialogContentText>
          </Box>
        );
      case 'confirm':
        return (
          <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" gap={2}>
            <AlertCircle size={40} color="#FF9800" />
            <DialogContentText sx={{ color: '#fff' }}>
              {message}
            </DialogContentText>
          </Box>
        );
      default:
        return null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={type !== 'loading' ? onClose : undefined}
      PaperProps={{
        style: {
          backgroundColor: '#27272A',
          minWidth: '300px',
          padding: '1rem'
        }
      }}
    >
      {title && (
        <DialogTitle sx={{ color: '#fff', textAlign: 'center' }}>
          {title}
        </DialogTitle>
      )}
      <DialogContent>
        {getAlertContent()}
      </DialogContent>
      {type !== 'loading' && (
        <DialogActions sx={{ justifyContent: 'center', gap: 1 }}>
          {type === 'confirm' && (
            <>
              <Button
                onClick={onConfirm}
                sx={{
                  backgroundColor: '#22C55E',
                  color: '#fff',
                  '&:hover': { backgroundColor: '#16A34A' }
                }}
              >
                Confirmar
              </Button>
              <Button
                onClick={onClose}
                sx={{
                  backgroundColor: '#FF3D3D',
                  color: '#fff',
                  '&:hover': { backgroundColor: '#FF5252' }
                }}
              >
                Cancelar
              </Button>
            </>
          )}
          {(type === 'success' || type === 'error') && (
            <Button
              onClick={onClose}
              sx={{
                backgroundColor: '#515151',
                color: '#fff',
                '&:hover': { backgroundColor: '#666666' }
              }}
            >
              Cerrar
            </Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};